import React, { useState, useEffect } from 'react'
import Mapa from './Mapa'

export default function LocalOcorrencia(props) {

    const [dados, setDados] = useState(null)
    const [complemento, setComplemento] = useState('')

    useEffect( () => { 
        const configurar = async () => { 
            setDados({ 
                isMarkerShow:false, 
                address:'',
                endereco: {
                    logradouro:"",
                    numero:"",
                    complemento:"",
                    cep:"",
                    bairro:"",
                    cidade:"",
                    estado:"",
                    pais:"",
                    latitude: -22.9720998,
                    longitude: -43.1873244
                }
            })
            setComplemento("")
        }
        configurar()
	},[])

    const abreFormularioDataHora = () => {
        props.setMensagem({ tipo:'LIMPAR', texto:'' })
        props.setLocal({ ...dados.endereco, address:dados.address, complemento })
        props.atuLinhaDoTempo('dataHora')
    }

    const abreFormularioContato = () => {
        setDados({ 
            isMarkerShow:false, 
            address:'',
            endereco: {
                logradouro:"",
                numero:"",
                complemento:"",
                cep:"",
                bairro:"",
                cidade:"",
                estado:"",
                pais:"",
                latitude: -22.9720998,
                longitude: -43.1873244
            }
        })
        setComplemento("")
        props.showFormulario('Denuncia',false,false)
    }

    const atuComplemento = event => {
        event.preventDefault()
        setComplemento(event.target.value)
    }

    if (props.linhaDoTempo.emPauta !== "local") {
        return null;
    }

    return (
        <fieldset className="border p-2 mt-4">
            <legend>
                <h4 className="ml-4"><small>Local da ocorrência:</small></h4> 
            </legend>
            <div className="form-group col-sm-12">
                <Mapa dados={ dados } setDados={ setDados } />
            </div>
            <div className="form-group col-sm-12">
                <strong>Você pode também</strong> arrastar o ícone para um ponto mais preciso.
            </div>
            <div className="form-group col-sm-12">
                <label>Complemento:</label>
                <input
                    id="idFormDenunciaComplemento"
                    name="complemento"
                    type="text"
                    className="form-control"
                    placeholder="Complemento (opcional)"
                    value={ complemento }
                    onChange={ atuComplemento }
                />
            </div>
            <div className="form-group col-sm-12">
                <div className="d-flex justify-content-between">
                    <button
                        type="button"
                        className="btn btn-outline-primary"
                        onClick={ abreFormularioContato }
                    >
                        Anterior
                    </button>
                    <button
                        type="button"
                        className="btn btn-outline-primary "
                        onClick={ abreFormularioDataHora }
                    >
                        Próximo
                    </button>
                </div>
            </div>
        </fieldset>
    )
}